import { takeLatest, call, delay, race, put, select } from 'redux-saga/effects';
import { projectsSlice } from 'app-entities/projects/projects-slice';
import { fetchProjectsApi } from 'app-entities/projects/api/fetch-projects.api';
import { PayloadAction } from '@reduxjs/toolkit';
import { TResponseError } from 'common/types/response-error.type';
import { TRequestProjectPayload } from 'app-entities/projects/types/request-project-payload.type';
import { TExtendedProject } from 'app-entities/projects/types/project.type';
import { mapProjectsResponseForUiModel } from 'app-entities/projects/helpers/map-projects-response-for-ui-model.helper';
import { TSuccessResponse } from 'app-entities/projects/types/success-projects-response';
import {
  TIMEOUT_FOR_BROWSER_REQUEST,
  TIMEOUT_FOR_SSR_REQUEST,
  ZERO_PAGE,
} from 'app-entities/projects/projects.const';
import { snackbarSlice } from 'store/snakbar/snakbar-slice';
import { envSlice } from 'store/env-slice';

export function* setListLoadError(errorObj: TResponseError, page: number) {
  yield put(projectsSlice.actions.setError(errorObj));

  if (page > ZERO_PAGE) {
    yield put(
      snackbarSlice.actions.callSnackbar({
        title: 'Не удалось загрузить',
        content: 'Попробуйте ещё раз позже',
      })
    );
  }
}

export function* searchProjectsSaga({ payload }: PayloadAction<TRequestProjectPayload>) {
  try {
    const { regionId, showProjectMinPrice, showProjectName, page, size, inspirationRooms } = payload;

    const bodyForRequest = {
      regionId: parseInt(regionId),
      showProjectMinPrice,
      showProjectName,
      inspirationRooms: inspirationRooms || [],
    };

    const host: string = yield select(envSlice.selectors.selectHost);
    const apiKey: string | undefined = yield select(envSlice.selectors.selectApiKey);

    const timeout = page === ZERO_PAGE ? TIMEOUT_FOR_SSR_REQUEST : TIMEOUT_FOR_BROWSER_REQUEST;

    const { response }: { response: TSuccessResponse } = yield race({
      response: call(fetchProjectsApi, {
        body: bodyForRequest,
        config: {
          params: {
            page: page.toString(),
            size: size.toString(),
          },
          host,
          apiKey,
        },
      }),
      timeout: delay(timeout),
    });

    if (response) {
      const mappedProjects: TExtendedProject[] = mapProjectsResponseForUiModel(response.items);

      yield put(projectsSlice.actions.setSuccessProjectsResponse({ ...response, items: mappedProjects }));
    } else {
      yield call(setListLoadError, { message: 'Timeout error' }, page);
    }
  } catch (error: unknown) {
    let defaultError: { message: string; name?: string } = {
      message: 'Unknown error',
    };

    if (error instanceof Error) {
      defaultError = {
        message: error.message,
        name: error.name,
      };
    }

    yield call(setListLoadError, defaultError, payload.page);
  }
}

export function* runSearchProjectsDetector() {
  yield takeLatest(projectsSlice.actions.requestProjects.type, searchProjectsSaga);
}
